/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PersonalDocument = {
  properties: {
    status: {
      type: 'PersonalDocumentStatus',
      isRequired: true,
    },
    person_document_config_id: {
      type: 'string',
      isRequired: true,
    },
    person_id: {
      type: 'string',
      isRequired: true,
    },
    files: {
      type: 'array',
      contains: {
        type: 'File',
      },
      isRequired: true,
    },
  },
} as const;
